import { APIValidationError } from '../../types/api/api';
import { Result, validatedApiCall } from '../api';

export const bajaMiembro = async (): Promise<
  Result<boolean, APIValidationError>
> => {
  return validatedApiCall<boolean>('/api/miembros', {
    method: 'DELETE',
    auth: true,
  });
};
